module.exports = __webpack_public_path__ + "img/logo.19ce7232.png";